import * as React from "react";
import * as ReactDOM from "react-dom";
import App from "./App";
import "./Sass/style.css";
// import "@fortawesome/fontawesome-free/css/all.css";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import "react-tree-graph/dist/style.css";
import * as serviceWorker from "./serviceWorker";

ReactDOM.render(<App />, document.getElementById("root"));

serviceWorker.register();



// WEBPACK FOOTER //
// ./src/index.tsx